import { Component, DestroyRef, Inject, ViewChild, inject } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ServicesService } from 'src/services/services.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize } from 'rxjs/operators';

export interface TicketData {
  id: any;
}

export interface TicketElement {
  srNo: string;
  id: any;
  category: string;
  row: string;
  seat_no: string;
  assigned_to: string;
  action: any;
}

@Component({
  selector: 'app-tickets',
  templateUrl: './tickets.component.html',
  styleUrls: ['./tickets.component.scss'],
  standalone: false
})
export class TicketsComponent {
  displayedColumns: string[] = [
    'srNo',
    'category',
    'row',
    'seat_no',
    'assigned_to',
    // 'action',
  ];

  ELEMENT_DATA: TicketElement[] = [];
  private destoryRef = inject(DestroyRef);

  dataSource = new MatTableDataSource<TicketElement>();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  ticket_result: any;

  constructor(private service: ServicesService,
    private router: Router,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private spinner: NgxSpinnerService
  ) { }

  ngAfterViewInit() {
    this.Get_Tickets();
    this.dataSource.paginator = this.paginator;
  }

  AddTicket() {
    const dialogRef = this.dialog.open(add_edit_ticket, {
      data: {
        // id: this.id
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      this.Get_Tickets();
    });
  }

  EditTicket(id: any) {
    console.log(id);

    const dialogRef = this.dialog.open(add_edit_ticket, {
      data: {
        id: id
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.Get_Tickets();
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  Get_Tickets() {
    this.ELEMENT_DATA = [];
    this.spinner.show();
    this.service.get_ticket_master().pipe(takeUntilDestroyed(this.destoryRef), finalize(() => this.spinner.hide())).subscribe(
      (data: any) => {
        this.ticket_result = data.data;

        for (const item of this.ticket_result) {
          this.ELEMENT_DATA = this.ticket_result.map((item: any, index: number) => ({
            srNo: index + 1,
            auto_assign: item.auto_assign,
            id: item.id,
            category: item.category,
            row: item.row,
            seat_no: item.seat_no,
            assigned_to: item.assigned_to,
            action: item.id
          })
          );
        }

        this.dataSource = new MatTableDataSource<TicketElement>(this.ELEMENT_DATA);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.spinner.hide();
      });
  }

  DeleteTicket(id: any) {
    const buttonClicked = window.confirm('Are You Sure To Delete This Ticket?');
    if (buttonClicked === true) {
      this.service.delete_ticket_category(id).pipe(takeUntilDestroyed(this.destoryRef)).subscribe(
        (data: any) => {
          this.ELEMENT_DATA = this.ELEMENT_DATA.filter(item => item.id !== id);
          this.dataSource.data = this.ELEMENT_DATA;
          this.toastr.success("Ticket Deleted Succesfully");
        });
    }
  }
}



@Component({
  selector: 'add_edit_ticket',
  templateUrl: './add_edit_ticket.html',
  styleUrls: ['./tickets.component.scss'],
  standalone: false
})
export class add_edit_ticket {

  ScanningForm: FormGroup;
  private destoryRef = inject(DestroyRef);
  Ticket_data: any;
  result: any;
  hide = true;
  id: any
  row: any
  seat_no: any

  constructor(
    private member: FormBuilder,
    private service: ServicesService,
    private dialogRef: MatDialogRef<add_edit_ticket>,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: TicketData
  ) {
    this.id = data['id'];

    // Initialize form group
    this.ScanningForm = this.member.group({
      id: this.id,
      row: new FormControl(''),
      seat_no: new FormControl('', [Validators.required]),
    });
  }

  ngOnInit(): void {
    this.Get_Ticket_By_Id(this.id)
  }

  Get_Ticket_By_Id(id: any) {
    this.service.get_ticket_by_id(id).subscribe(
      (data: any) => {
        this.Ticket_data = data.data;
        this.id = this.Ticket_data[0].id;
        this.row = this.Ticket_data[0].row;
        this.seat_no = this.Ticket_data[0].seat_no;
      });
  }

  onFormSubmit() {
    const formData = this.ScanningForm.value;
    const hasNonEmptyField = Object.values(formData).some(value => value !== null && value !== '');
    if (this.ScanningForm.valid && hasNonEmptyField) {

      if (this.id) {
        this.service.edit_ticket(this.ScanningForm.value).pipe(takeUntilDestroyed(this.destoryRef)).subscribe({
          next: (val: any) => {
            if (val.flag == true) {
              this.toastr.success(val.msg);
              this.dialogRef.close(true);
            } else {
              this.toastr.error(val.msg);
            }
          },
          error: (err: any) => {
            console.error(err);
          },
        });
      } else {
        this.service.add_ticket_category(this.ScanningForm.value).pipe(takeUntilDestroyed(this.destoryRef)).subscribe({

          next: (val: any) => {
            if (val.flag == true) {
              this.toastr.success(val.msg);
              this.dialogRef.close(true);
            } else {
              this.toastr.error(val.msg);
            }
          },
          error: (err: any) => {
            console.error(err);
          },
        });
      }
    } else {
      this.toastr.error("Please Fill Required Fields")
    }
  }
}
